import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const BatmaidLogo = (props: Icon): React.ReactElement =>
  props.variant === "line" ? (
    <svg
      style={{ ...style(props.size), ...props.style }}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 24 24"
    >
      <defs>
        <path
          d="M4,11.9824703 C4.00185892,7.57824514 7.59315582,3.99664157 12.0040969,4 C16.4187997,4.00336315 20.0069694,7.60118026 20,12.0174407 C19.9930556,16.4189863 16.3989488,20.001589 11.99186,20 C7.57371278,19.9983645 3.99814253,16.411311 4,11.9824703 Z M12.0035848,5 C15.8664497,5.00294276 19.0060982,8.15103273 19,12.0152606 C18.9939237,15.866613 15.8490802,19.0013904 11.9928775,19 C8.12699868,18.9985689 4.99837472,15.8598971 5,11.9846615 C5.00162655,8.13096449 8.14401134,4.99706138 12.0035848,5 Z M12.5,16.5 L11.5,16.5 C11.5630118,16.7098677 11.7204616,16.8068765 11.948208,16.8268596 C12.2222695,16.8509301 12.3957248,16.7458827 12.5,16.5 L12.5,16.5 Z M12.0050054,6 C11.580926,6.00022545 11.3835042,6.25323994 11.4293606,6.7302448 C11.5112667,7.58154345 11.5992962,8.43243648 11.6667456,9.28486184 C11.6996646,9.70061863 11.7508156,10.1248483 11.5090107,10.5129781 C11.3307878,10.7991179 11.3454287,10.8510368 11.6245264,11.091973 C11.5671599,11.1102257 11.5315706,11.1237913 11.4948763,11.1329402 C10.6555112,11.3420129 10.2669291,11.8291131 10.2432643,12.6769866 C10.2298665,13.1572814 10.1764595,13.6356384 10.0366343,14.0982664 C9.86692892,14.6598197 9.70942424,15.2304769 9.08032634,15.5000766 C8.96186404,15.5508237 8.97714949,15.6529038 9.1082269,15.7133407 C9.3045898,15.8039283 9.51435048,15.8472842 9.72599883,15.8725676 C11.1550511,16.0432871 12.5866355,16.0291355 14.018174,15.9088928 C14.2914706,15.885953 14.5658722,15.8458871 14.8247581,15.7460153 C14.8989755,15.7173518 15.0027969,15.7077071 15,15.5994075 C14.9975943,15.5104423 14.9169773,15.485249 14.8437729,15.4570362 C14.7358078,15.4153478 14.6427599,15.3500436 14.5606236,15.2692358 C14.3165627,15.029156 14.1803287,14.7294055 14.0698314,14.4164048 C13.852382,13.8004538 13.792207,13.1614277 13.7639842,12.5146499 C13.7377411,11.9128954 13.4236065,11.4857363 12.8618198,11.2411496 C12.8134466,11.2200726 12.7636921,11.2020352 12.7131686,11.1855418 L12.4056962,11.0931447 C12.6674367,10.8213818 12.6662396,10.8220127 12.4787165,10.4689011 C12.3712579,10.2665887 12.3049595,10.0517021 12.3194623,9.82171766 C12.3539006,9.27521718 12.3871419,8.7284463 12.4335968,8.18280213 C12.478118,7.65973728 12.5517368,7.13883571 12.5878786,6.61536523 C12.6154569,6.21641899 12.3928509,5.99981984 12.0050054,6 Z"
          id="path-1-batmaid-logo"
        ></path>
      </defs>
      <g
        id="Project-EOT"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Atom/icon/brand/batmaid/line">
          <mask
            id="mask-2-batmaid-logo"
            fill={props.color || theme.palette.grey600}
          >
            <use xlinkHref="#path-1-batmaid-logo"></use>
          </mask>
          <use
            id="Mask"
            fill={props.color || theme.palette.grey600}
            xlinkHref="#path-1-batmaid-logo"
          ></use>
          <g
            id="Group"
            mask="url(#mask-2-batmaid-logo)"
            fill={props.color || theme.palette.grey600}
            fillOpacity="0.6"
          >
            <g id="🎨-color">
              <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ) : (
    <svg
      style={{ ...style(props.size), ...props.style }}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 24 24"
    >
      <defs>
        <path
          d="M12.0040969,4 C16.4187997,4.00336315 20.0069694,7.60118026 20,12.0174407 C19.9930556,16.4189863 16.3989488,20.001589 11.99186,20 C7.57371278,19.9983645 3.99814253,16.411311 4,11.9824703 C4.00185892,7.57824514 7.59315582,3.99664157 12.0040969,4 Z M12.5,16.5 L11.5,16.5 C11.5630118,16.7098677 11.7204616,16.8068765 11.948208,16.8268596 C12.2222695,16.8509301 12.3957248,16.7458827 12.5,16.5 L12.5,16.5 Z M12.0050054,6 C11.580926,6.00022545 11.3835042,6.25323994 11.4293606,6.7302448 C11.5112667,7.58154345 11.5992962,8.43243648 11.6667456,9.28486184 C11.6996646,9.70061863 11.7508156,10.1248483 11.5090107,10.5129781 C11.3307878,10.7991179 11.3454287,10.8510368 11.6245264,11.091973 C11.5671599,11.1102257 11.5315706,11.1237913 11.4948763,11.1329402 C10.6555112,11.3420129 10.2669291,11.8291131 10.2432643,12.6769866 C10.2298665,13.1572814 10.1764595,13.6356384 10.0366343,14.0982664 C9.86692892,14.6598197 9.70942424,15.2304769 9.08032634,15.5000766 C8.96186404,15.5508237 8.97714949,15.6529038 9.1082269,15.7133407 C9.3045898,15.8039283 9.51435048,15.8472842 9.72599883,15.8725676 C11.1550511,16.0432871 12.5866355,16.0291355 14.018174,15.9088928 C14.2914706,15.885953 14.5658722,15.8458871 14.8247581,15.7460153 C14.8989755,15.7173518 15.0027969,15.7077071 15,15.5994075 C14.9975943,15.5104423 14.9169773,15.485249 14.8437729,15.4570362 C14.7358078,15.4153478 14.6427599,15.3500436 14.5606236,15.2692358 C14.3165627,15.029156 14.1803287,14.7294055 14.0698314,14.4164048 C13.852382,13.8004538 13.792207,13.1614277 13.7639842,12.5146499 C13.7377411,11.9128954 13.4236065,11.4857363 12.8618198,11.2411496 C12.8134466,11.2200726 12.7636921,11.2020352 12.7131686,11.1855418 L12.4056962,11.0931447 C12.6674367,10.8213818 12.6662396,10.8220127 12.4787165,10.4689011 C12.3712579,10.2665887 12.3049595,10.0517021 12.3194623,9.82171766 C12.3539006,9.27521718 12.3871419,8.7284463 12.4335968,8.18280213 C12.478118,7.65973728 12.5517368,7.13883571 12.5878786,6.61536523 C12.6154569,6.21641899 12.3928509,5.99981984 12.0050054,6 Z"
          id="path-1-batmaid-logo"
        ></path>
      </defs>
      <g
        id="Project-EOT"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Atom/icon/brand/batmaid/solid">
          <mask
            id="mask-2-batmaid-logo"
            fill={props.color || theme.palette.grey600}
          >
            <use xlinkHref="#path-1-batmaid-logo"></use>
          </mask>
          <use
            id="Mask"
            fill={props.color || theme.palette.grey600}
            xlinkHref="#path-1-batmaid-logo"
          ></use>
          <g
            id="Group"
            mask="url(#mask-2-batmaid-logo)"
            fill={props.color || theme.palette.grey600}
            fillOpacity="0.6"
          >
            <g id="🎨-color">
              <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
